/**
 * Wire-контракты связей товаров Platform (`Platform.Contracts/Catalog`, FIX-A2)
 * и их проверка на границе: неожиданная форма — `invalid-response`, а не пустой экран.
 */
import { flag, integer, list, record, text } from '../../../shared/decode'
import type { CatalogIdentity, CatalogLinkResult, LinkedProduct } from '../model/types'

function decodeIdentity(raw: unknown, name: string): CatalogIdentity {
  const item = record(raw, name)
  return {
    resourceId: text(item.resourceId, `${name}.resourceId`),
    remoteKey: text(item.remoteKey, `${name}.remoteKey`),
    origin: text(item.origin, `${name}.origin`),
    linkedAt: text(item.linkedAt, `${name}.linkedAt`),
  }
}

export function decodeLinkedProduct(raw: unknown, name = 'product'): LinkedProduct {
  const item = record(raw, name)
  return {
    id: text(item.id, `${name}.id`),
    name: text(item.name, `${name}.name`),
    version: integer(item.version, `${name}.version`),
    identities: list(item.identities, `${name}.identities`, decodeIdentity),
    hiddenIdentities: integer(item.hiddenIdentities, `${name}.hiddenIdentities`),
  }
}

export function decodeLinkedProducts(raw: unknown): readonly LinkedProduct[] {
  return list(raw, 'products', decodeLinkedProduct)
}

export function decodeLinkResult(raw: unknown): CatalogLinkResult {
  const item = record(raw, 'result')
  return {
    operationId: text(item.operationId, 'result.operationId'),
    replayed: flag(item.replayed, 'result.replayed'),
    productCreated: flag(item.productCreated, 'result.productCreated'),
    changed: list(item.changed, 'result.changed', (entry, name) => {
      const card = record(entry, name)
      return { resourceId: text(card.resourceId, `${name}.resourceId`), remoteKey: text(card.remoteKey, `${name}.remoteKey`) }
    }),
    product: item.product === null || item.product === undefined ? null : decodeLinkedProduct(item.product, 'result.product'),
  }
}
